import React from 'react';
import { isSafari } from 'react-device-detect';
import { getRatesAndFees, getFeatureValue } from 'featureToggles';
import { byCard, getProductName } from 'utils';
import { ANNUAL_FEE } from 'featureToggles/defaultValues';
import {
  PRODUCT_CODE_AFS,
  PRODUCT_CODE_AU_GEM,
  PRODUCT_CODE_DAVID_JONES_PREMIERE,
  PRODUCT_CODE_DAVID_JONES_PRESTIGE,
  PRODUCT_CODE_GO,
  PRODUCT_CODE_LOW_RATE,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
  config,
  setConfig,
} from '../../../../_config';
import { DjFinancialTable } from './DjFinancialTable';
import { Au28DFinancialTable } from './Au28DFinancialTable';
import { AuGemFinancialTable } from './AuGemFinancialTable';
import { GoFinancialTable } from './GoFinancialTable';
import { AfsGemFinancialTable } from './AfsFinancialTable';
import { LowRateFinancialTable } from './LowRateFinancialTable';

export function FinancialTable() {
  const queryParams = new URLSearchParams(window.location.search);
  const creditLimit = queryParams.get('creditLimit');
  const accountNumber = queryParams.get('accountNumber');
  const applicationDate = queryParams.get('applicationDate');
  const productCode = queryParams.get('productCode');

  if (!config.productCode && productCode) {
    setConfig({ productCode });
    return null;
  }

  const downloadOrPrintFile = () => {
    if (isSafari) {
      document.execCommand('print', false, null);
    }
    window.print();
  };
  const productName = getProductName();
  const ratesAndFees = getRatesAndFees();
  const fee = getFeatureValue(ANNUAL_FEE);

  const statementDate = new Date(applicationDate).toLocaleDateString('en-AU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const ProductFinancialTable = byCard({
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: DjFinancialTable,
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: DjFinancialTable,
    [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: Au28DFinancialTable,
    [PRODUCT_CODE_AU_GEM]: AuGemFinancialTable,
    [PRODUCT_CODE_GO]: GoFinancialTable,
    [PRODUCT_CODE_AFS]: AfsGemFinancialTable,
    [PRODUCT_CODE_LOW_RATE]: LowRateFinancialTable,
  });

  return (
    <ProductFinancialTable
      ratesAndFees={ratesAndFees || {}}
      statementDate={statementDate}
      downloadOrPrintFile={downloadOrPrintFile}
      productName={productName}
      accountNumber={accountNumber}
      creditLimit={creditLimit}
      productCode={productCode}
      feesCharge={fee?.feesCharge || {}}
    />
  );
}
